import React, {Component} from 'react';
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types';
import ReactLoading from "react-loading";
import {Container, Row, Col, Card, CardBody, Button} from 'reactstrap';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

import RegisterField from '../../../views/controls/_FieldValication'
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { logout } from '../../../views/client/actions'
import { validateRegister } from '../../../lib/validation'

import {
  REGISTER_SUCCESS,
} from './constants'

// Import actions
import registerRequest from './actions';

class Register extends Component {
  // Pass the correct proptypes in for validation
  static propTypes = {
    handleSubmit: PropTypes.func,
    registerRequest: PropTypes.func,
    logout: PropTypes.func,
    login: PropTypes.shape({
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
 
  constructor(props) {
    super(props);
  }

  submit = (values) => {
    if (!this.props.valid)
    {
      return false;
    }
    this.props.registerRequest(values)
  }

  backToLogin = () => {
    this.props.logout();
    this.props.history.push('/login');
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.register.type == REGISTER_SUCCESS){
      setTimeout(() => this.backToLogin(), 3000);
    }
  }

  render() {
    const {  
      handleSubmit, // remember, Redux Form injects this into our props
      register: {
        requesting,
        successful,
        messages,
        errors,
      },
      // fields: { username, fullname }
    } = this.props
    
    return (
      <div className="app flex-row align-items-center bg-master ">
        <Container>
          <Row>
            <Col md="12">
            <div className="logo">
              <a href="https://sunphar.win">
                  <img alt="Logo" src="../img/logo.png" />
              </a>
            </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" xs="12" sm="10">
              <Card className="mx-6">
                <CardBody className="p-4">
                  <BlockUi tag="div" blocking={requesting}>
                    <form className="widget-form" method="post" onSubmit={handleSubmit(this.submit)}>
                      <h1 className="text-center">Đăng kí tài khoản</h1>
                      <p className="text-muted">Thực hiện tạo mới tài khoản</p>
                      <Field icon="icon-user" type="text" autocomplete="off" name="username" placeholder="Tài khoản ví dụ: taikhoan1" component={RegisterField} className="form-control"/>
                      <Field icon="icon-user" type="text" autocomplete="off" name="fullname" placeholder="Họ tên ví dụ: Tài khoản 1" component={RegisterField} className="form-control"/>
                      <Field iconText="@" type="email" autocomplete="off" name="email" placeholder="Email ví dụ: taikhoan1@gmail.com" component={RegisterField} className="form-control"/>
                      <Field icon="icon-phone" type="text" autocomplete="off" name="phone" placeholder="Số điện thoại" component={RegisterField} className="form-control"/>
                      <Field icon="icon-lock" type="password" autocomplete="off" name="password" placeholder="Mật khẩu" component={RegisterField} className="form-control"/>
                      <Field icon="icon-lock" type="password" autocomplete="off" name="password_confirm" placeholder="Nhập lại mật khẩu" component={RegisterField} className="form-control"/>
                      <Field icon="icon-user" type="text" autocomplete="off" name="storename" placeholder="Tên nhà thuốc" component={RegisterField} className="form-control"/>
                      <Field icon="icon-home" type="text" autocomplete="off" name="storeaddress" placeholder="Địa chỉ nhà thuốc" component={RegisterField} className="form-control"/>
                      {requesting && (
                        <ReactLoading type="bubbles" color="#84c752" />
                      )}
                      {!requesting && !!errors.length && (
                        <Errors message="Failure to signup due to:" errors={errors} />
                      )}
                      {!this.props.valid && (
                        <Errors message="Failure to signup due to:" errors={errors} />
                      )}
                      {!requesting && !!messages.length && (
                        <Messages messages={messages} />
                      )}
                      {!requesting && successful && (
                        <div>
                          <Button onClick={this.backToLogin} color="link" className="px-4" block>Quay về đăng nhập »</Button>
                        </div>
                      )}
                      {!requesting && !successful && (
                        <Button disabled={!this.props.valid} color="primary" className="px-4" action="submit" block>Đăng kí</Button>
                      )}
                    </form>
                    <Row className="auth-messages">
                      <Col md="12">
                      
                      {/* Redux Router's <Link> component for quick navigation of routes */}
                      {!requesting && !successful && (
                        <Button onClick={this.backToLogin} color="link" className="px-4" block><span>Bạn đã có tài khoản? Kích để đăng nhập »</span></Button>
                      )}
                      </Col>
                    </Row>
                  </BlockUi>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

// Grab only the piece of state we need
const mapStateToProps = state => ({
  register: state.register,
})

// make Redux state piece of `register` and our action `registerRequest`
// available in this.props within our component
const connected = connect(mapStateToProps, { registerRequest, logout })(Register)

// in our Redux's state, this form will be available in 'form.register'
const formed = reduxForm({
  form: 'register',
  validate: validateRegister,
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js